import { render, staticRenderFns } from "./PhotoKicker.vue?vue&type=template&id=7d50dd49"
import script from "./PhotoKicker.vue?vue&type=script&lang=js"
export * from "./PhotoKicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports